import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Lottie from 'react-lottie';
import { useHistory } from 'react-router-dom';
import gs from '../../global.css';
import s from './style.css';
import { celebrateAnimation } from '../../../assets/lottie';
import { auth } from '../../actions';
import { Button } from '../../components';
const WelcomeScreen = (props) => {
    useEffect(() => {
        props.refreshUser();
    }, []);
    const history = useHistory();
    return (React.createElement("div", { className: gs.main },
        React.createElement("div", { className: `${gs.screenContainer} ${gs.centerScreen}` },
            React.createElement("div", { className: gs.box },
                React.createElement(Lottie, { options: {
                        loop: true,
                        animationData: celebrateAnimation,
                    }, height: 400, width: 400, isStopped: false, isPaused: false }),
                React.createElement("p", { className: s.welcome },
                    "Welcome to",
                    ' ',
                    React.createElement("span", { className: s.sticknet },
                        "Sticknet ",
                        React.createElement("span", { className: s.premium }, "Premium"))),
                React.createElement(Button, { text: 'Back to My Vault', colored: true, onClick: () => history.replace('/vault/files'), style: { marginBottom: '28px', width: '27vw', height: '40px', marginTop: '10vh' } })))));
};
const connector = connect(null, { ...auth });
export default connector(WelcomeScreen);
